// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".locations-grid{display:grid;grid-gap:1em;grid-template-columns:1fr}@media screen and (min-width: 640px){.locations-grid{grid-template-columns:repeat(auto-fill, minmax(200px, 1fr))}}\n", ""]);
// Exports
module.exports = exports;
